module.exports = __webpack_public_path__ + "static/img/14000203.e3e49f25.png";